Pixlee.module('SingleEmbedsApp', function(SingleEmbedsApp, App, Backbone, Marionette, $) {
	var _this = this,
		API;
	SingleEmbedsApp.Router = Marionette.AppRouter.extend({
		appRoutes: {
			"": "embed"
		}
	});

var API = {
	embed: function(){
		var href = window.location.href;
		gon.current_album_photo_id = href.substr(href.lastIndexOf('/') + 1);
		this.embedController = new SingleEmbedsApp.Embed.Controller();
	}
	};

	SingleEmbedsApp.on("start", function() {
		new SingleEmbedsApp.Router({
			controller: API
		});
	});

});